import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

import type {
  ConvertPdfToDxfRequestBody,
  ConvertPdfToDxfResponse,
} from './types';

export type UseConvertPdfToDxfParams = {
  fileUuid: string;
};

export const getConvertPdfToDxfMutationKey = (
  params: UseConvertPdfToDxfParams,
) => ['parts', 'files', params.fileUuid, 'convertPdfToDxf'] as const;

export const useConvertPdfToDxf: MutationFunction<
  ConvertPdfToDxfResponse,
  ConvertPdfToDxfRequestBody,
  [UseConvertPdfToDxfParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const urlPath = `/parts/files/${params.fileUuid}/convert_pdf_to_dxf`;
  const mutationKey = getConvertPdfToDxfMutationKey(params);

  return useMutation({
    mutationFn: (body) =>
      request<ConvertPdfToDxfResponse>(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      }),
    ...queryOptions,
    mutationKey,
  });
};
